module.exports = __webpack_public_path__ + "static/media/net90.fbbc7f64.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/icons/net90.svg
 ** module id = 458
 ** module chunks = 0
 **/